import {passwordForgotten as types} from '../actions/actiontypes'
import formReducer from './formReducer'

const passwordForgottenReducer = formReducer(types)

export {passwordForgottenReducer}
